/* eslint-disable @typescript-eslint/explicit-function-return-type */
import Cell from 'components/data-visualization/Table/Cell';
import { definitionValue } from 'styles/base-classes';
import styled from 'styled-components/macro';
import { ThemeProps } from 'types/styled';
import Span from 'components/elements/span';

export const CellContent = styled('div')<any>`
  ${definitionValue};
  ${({ paddingRight }) =>
    paddingRight ? `padding-right: ${paddingRight};` : ''}
  font-weight: 400;
  display: flex;
  flex-flow: row nowrap;
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  align-items: center;
  flex: 1 1 auto;
  ${({ isRightAligned }) =>
    isRightAligned ? `justify-content: flex-end;` : ''}

  ${({ isCentered }) => (isCentered ? `justify-content: center;` : '')}

  @media screen and (min-width: 50em) {
    ${({ isCentered }) => (!isCentered ? `justify-content: flex-end;` : '')}
  }
`;

export const EntityCell = styled(Cell)`
  &:first-of-type {
    flex-basis: 100%;
    padding: 0;
  }

  &:last-of-type {
    margin-right: 0;
    flex-basis: 100%;
  }

  &:first-child:last-child {
    padding-bottom: ${({ theme }) => theme.spacing.small};
  }

  @media screen and (min-width: 50em) {
    &,
    &:first-of-type {
      padding-top: 0;
      padding-bottom: 0;
    }

    &:first-child:last-child {
      padding-bottom: 0;
    }
  }
`;

export const BoldEntityCell = styled(EntityCell)`
  font-weight: 600;
`;

export const HighlightedEntityCell = styled(EntityCell)<ThemeProps<'td'>>`
  ${({ highlighted }) =>
    highlighted &&
    `
  font-weight: 600;
  `}
`;

export const ValueWrapper = styled.div<ThemeProps<'div'>>`
  margin-right: 0.5em;
  text-align: right;
  min-width: 4em;
  ${({ tableName }) =>
    tableName === 'BrowseOpus'
      ? 'text-align: center; min-width: 6em;'
      : 'text-align: right;min-width: 4em;'}
`;

export const SecondaryValue = styled(Span)<any>`
  color: ${({ theme, hasColor }): string =>
    hasColor ? theme[hasColor] : theme.CasperGrey};
`;

export const LabelName = styled('span')`
  color: ${({ theme }): string => theme.CasperGrey};
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  font-family: Proxima Nova;
  margin-right: ${({ theme }) => theme.spacing.xsmall};

  @media screen and (min-width: 50em) {
    font-size: 13.3px;
  }
`;

export const EntityInfoCell = styled('div')``;
